import {useQuery, gql} from '@apollo/client'

export const GET_CLIENT_AUDIT_DETAILS = gql`
  query getAuditDetails($fetchType: String!, $page: Int!, $pageSize: Int) {
    getAuditDetails(fetchType: $fetchType, page: $page, pageSize: $pageSize) {
      page
      pageSize
      totalCount
      clients {
        PROPERTY
        CLIENT_ID
        CHANGED_BY
        CHANGED_DATA
        EVENT_TYPE
        USER_ROLE
        AUDITED_AT
      }
    }
  }
`

export function useClientAuditDetails({page, pageSize, skip = false}) {
  const {
    data: clientAuditDetailsData,
    loading: loadingClientAuditDetails,
    error: errorClientAuditDetails,
    refetch: refetchClientAuditDetails
  } = useQuery(GET_CLIENT_AUDIT_DETAILS, {
    context: {clientName: 'adminPanel'},
    variables: {fetchType: 'client', page, pageSize},
    notifyOnNetworkStatusChange: true,
    errorPolicy: 'all',
    skip
  })

  return {clientAuditDetailsData, loadingClientAuditDetails, errorClientAuditDetails, refetchClientAuditDetails}
}
